import React, { useEffect, useRef } from 'react';

interface IFootnoteGroupProps {
    analytics?: string;
    dark?: boolean;
    footnoteGroupTitle: string;
    open?: boolean;
    children: React.ReactNode;
    onOpen?: () => void;
    onClick?: () => void;
}

export enum FootnoteGoupListType {
    LIST = 'list',
    ORDERED_LIST = 'ordered-list'
}

// eslint-disable-next-line
export const FootnoteGroup: React.FC<IFootnoteGroupProps> = ({
    footnoteGroupTitle,
    analytics,
    dark,
    open,
    children,
    onOpen,
    onClick
}) => {
    const ref = useRef(null);

    useEffect(() => {
        ref.current.addEventListener('dsdFootnoteGroupChange', () => {
            if (onOpen) onOpen();
        });

        ref.current.addEventListener('dsdFootnoteGroupClick', () => {
            if (onClick) onClick();
        });
    }, []);

    return (
        <>
            {/*@ts-ignore*/}
            <dsd-footnote-group
                ref={ref}
                analytics={analytics}
                dark={dark}
                open={open}
                footnote-group-title={footnoteGroupTitle}
                data-testid={'footnote_group'}
            >
                <div slot="list">{children}</div>
                {/*@ts-ignore*/}
            </dsd-footnote-group>
        </>
    );
};
